export default {
  birthDate: 'Date of Birth',
  birthDay: 'DD',
  birthMonth: 'MM',
  birthYear: 'YYYY',
  certified: {
    title: 'Registered User',
    register: 'Registered User Sign Up',
    desc:
      'Registered Users have access to all of the electronic services offered by the NLG',
    modal: {
      title: 'Confirmation',
      desc:
        'To enroll as a Registered User, please confirm if you already have an account or enroll at this time',
      user: {
        registered: 'I already have an account',
        new: 'I am a new user'
      },
      back: 'Previous'
    },
    taxis: {
      desc:
        'Authentication of User details (Name, Surname, Maiden Name, Date of Birth) requires connection to TAXISnet',
      connect: 'Login to TAXISnet'
    },
    basic: {
      desc:
        'Please enter your AMKA (Social Security number) and email or mobile phone for authentication'
    },
    account: {
      desc: 'Please enter your personal information',
      extraDesc: 'Further instructions, if required'
    },
    error: {
      generic: 'We apologise, there was a problem!',
      birthdate: 'The IDIKA registered Date of birth is incorrect',
      registered: 'A Registered User with VAT number: %{tin} already exists',
      registrationMail: 'Account e-mail: %{mail}',
      registrationPhone: 'Account mobile phone: %{phone}'
    }
  },
  create: 'Create an account',
  error: {
    age:
      'To enroll as a Registered or Simple User, you must be at least 15yrs of age',
    expired: 'End of session',
    generic: 'General error',
    ssn: {
      invalid: 'AMKA is invalid',
      notFound: 'AMKA was not found',
      mismatch: {
        mailOrPhone: 'AMKA and email or mobile phone do not match',
        tin: 'AMKA and VAT number do not match'
      },
      registered: 'Provided AMKA already exists'
    },
    mailOrPhone: {
      registered: 'Provided email or mobile phone already exists',
      malformed: 'Provided email or mobile phone is invalid'
    },
    pin: 'Incorrect PIN',
    captcha: 'Incorrect Captcha'
  },
  faq: 'Frequently Asked Questions',
  fathername: "Father's name",
  firstname: 'Name',
  footer: {
    usage: 'User Guide',
    info: 'Useful information',
    lang: {
      el: 'Greek - GR',
      en: 'English – EN'
    },
    copyright: '© 2017 National Library of Greece. All rights reserved.'
  },
  header: {
    logo: {
      title: 'Go to Registration Home Page'
    }
  },
  lastname: 'Surname',
  login: 'Login',
  mail: 'E-mail',
  next: 'Next',
  orRegisterAs: 'Register as',
  password: {
    original: 'Password',
    repeat: 'Confirm New Password',
    unassigned: 'Unsigned Unicode characters are prohibited',
    notAllNums: 'Must contain at least one non-numeric character',
    similar:
      'Password cannot be the same as provided e-mail address or mobile phone',
    nonAlpha:
      'Must include at least %{smart_count} one numeric digit or one non-alphabetic character |||| Must include at least %{smart_count} two digits or two non-alphabetic characters',
    consecutiveNums:
      'May not contain more than %{smart_count} ascending or descending consecutive numbers',
    length:
      'Must contain at least %{smart_count} character |||| Must contain at least %{smart_count} characters',
    uniq:
      'Must contain at least %{smart_count} special character |||| Must contain at least %{smart_count} special characters'
  },
  phone: 'Mobile phone number',
  pin: {
    title: 'PIN',
    desc:
      'Please enter the PIN you received via e-mail or mobile phone for identification',
    resend: {
      click: 'Click',
      here: 'here',
      action: 'to resend your PIN'
    }
  },
  prefix: 'Prefix',
  privacyPolicy: 'Personal data protection policy',
  register: 'Register',
  ssn: 'AMKA',
  staff: {
    register: 'Staff registration',
    basic: {
      desc:
        'Please enter your AMKA and e-mail or mobile phone for authentication'
    },
    account: {
      desc:
        'Confirm below information and enter desired password for your account',
      extraDesc: 'Further instructions, if required'
    },
    error: {
      birthdate: 'Registered Birth Date in HRMS is incorrect',
      HRMSPhoneMailNull:
        'Phone and external e-mail have not been entered in HRMS',
      HRMSNoLogin: 'There is no user login in HRMS',
      HRMSNoTin: 'There is no VAT number in HRMS'
    }
  },
  success: {
    title: 'Congratulations!',
    desc:
      'You have successfully registered. You may proceed by clicking on the links below',
    manage: {
      password: 'Manage password',
      account: 'Manage account'
    }
  },
  taxis: {
    desc:
      'If you wish to sign in with a different TAXISnet account, you must log out and repeat the registration process',
    logout: 'Disconnect from TAXISnet'
  },
  tin: 'VAT number',
  title: 'National Library of Greece',
  tooltip: {
    pin: '%{smart_count} digit |||| %{smart_count} digits',
    year: 'From %{from} to %{to}',
    name:
      'Greek or Latin. Hyphens (-) and spaces allowed, while apostrophes are only allowed in Latin.'
  },
  tos: {
    read: 'I have read and agree with all of the',
    link: 'Privacy Policy'
  },
  unload: 'Changes you made may not be saved',
  user: {
    title: 'Simple User',
    register: 'Simple User registration',
    desc:
      'Simple Users receive updates on the services and activities of the NLG',
    basic: {
      desc: 'Please enter your e-mail or mobile phone for authentication'
    },
    account: {
      desc: 'Please enter your personal information',
      extraDesc: 'Further instructions, if required'
    }
  },
  version: 'Version %{version}'
}
